export const getLanguagePrefix = (language) => {
  const [prefix] = language.split('_');
  return prefix;
};
